import { createMemoryHistory, createRouter } from 'vue-router'

const routes = [
  {
    path: '/',
    component: () => import('../views/ReportsIndexView.vue')
  },
];

function initializeRouter() {
  return createRouter({
    history: createMemoryHistory(),
    routes,
  });
}

export default initializeRouter();
